import(/* webpackMode: "eager" */ "/vercel/path0/src/app/footer/esa/page.js");
